import React from 'react';
import { Search, Users, Globe2 } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { useLang } from '../../context/LanguageContext';
import { useMarketingStudio } from '../../hooks/useMarketingStudio';
import { marketingCopy } from '../../data/marketing-copy';
import { MarketingBrief } from './marketing/MarketingBrief';
import { MarketingOutput } from './marketing/MarketingOutput';

export const MarketingStudio = () => {
  const { lang } = useLang();
  const state = useMarketingStudio(lang);
  const copy = marketingCopy[lang];
  const channels = [{ value: 'google', icon: Search, text: 'Google Ads' }, { value: 'meta', icon: Users, text: 'Meta Ads' }, { value: 'open-web', icon: Globe2, text: copy.openWeb }];
  return <section className="studio-section site-container" data-testid="marketing-studio">
    <Tabs value={state.channel} onValueChange={state.selectChannel}><TabsList className="studio-tabs" data-testid="studio-channel-tabs">{channels.map(({ value, icon: Icon, text }) => <TabsTrigger disabled={state.busy} key={value} value={value} data-testid={`studio-tab-${value}`}><Icon size={16} />{text}</TabsTrigger>)}</TabsList></Tabs>
    <div className="studio-layout"><MarketingBrief state={state} copy={copy} /><MarketingOutput state={state} copy={copy} /></div>
  </section>;
};